import {Navigate, Outlet} from 'react-router-dom'
import {routes} from '@utilities/constants/routes.tsx'
import {useAuthStore} from '@features/user/store/store.ts'

export const PublicRoute = () => {
    const accessToken = useAuthStore(state => state.accessToken)
    const user = useAuthStore(state => state.user)

    return accessToken ? (
        <Navigate
            to={
                user && !user?.isAirbnbSsoConfigured
                    ? routes.LINK_AIRBNB_ACCOUNT.handle.fullPath
                    : routes.HOME.handle.fullPath
            }
        />
    ) : (
        <Outlet />
    )
}
